/* eslint-disable react-hooks/exhaustive-deps */
import IconClose from "@mui/icons-material/Close";
import IconView from "@mui/icons-material/RemoveRedEye";
import {
  Button,
  Grid,
  IconButton,
  MenuItem,
  TextField,
  Tooltip,
} from "@mui/material";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { isEmpty, validate } from "validate.js";
import {
  fetchApplications,
  resetStateApplications,
  setFormValues as setApplicationFormValues,
} from "../../app/slices/applicationsSlice";
import {
  applicationStatus,
  dateFormatWithTime,
  translateStatus,
} from "../../app/utils";
import TopLinks from "../../components/TopLinks/TopLinks";
import AppDataTable from "../../components/appDataTable/appDataTable";
import EmptyDataContainer from "../../components/emptyDataContainer/emptyDataContainer";
import ErrorContainer from "../../components/errorContainer/errorContainer";
import LoadingContainer from "../../components/loadingContainer/loadingContainer";
import ApplicationLanding from "./ApplicationLandingPage";
import { DBApplicationMapper } from "./DBApplicationMapper";

const UserApplications = ({ entity = null }) => {
  const {
    get: { data: listApplications, status: statusGet, error: errorGet },
  } = useSelector(({ applications }) => applications);
  const topLinks = [
    {
      name: "Dashboard",
      path: "/dashboard",
    },
    {
      name: "All Applications",
      isCurrent: false,
    },
  ];

  const columns = [
    {
      name: "APPLICATION_ID",
      label: "Application ID",
      options: {
        visible: false,
      },
    },
    {
      name: "SUBMITTED_AT",
      label: "Submission Date",
    },
    {
      name: "COMPANY_NAME",
      label: "Company Name",
    },
    {
      name: "INCORPORATION_NUMBER",
      label: "Incorporation Number",
    },
    {
      name: "CONTACT_PERSON_NAME",
      label: "Contact Person Name",
    },
    {
      name: "CONTACT_PERSON_EMAIL",
      label: "Contact Person Email",
    },
    {
      name: "CONTACT_PERSON_PHONE",
      label: "Contact Person Phone",
    },
    {
      name: "PHYSICAL_ADDRESS",
      label: "Physical Address",
    },
    {
      name: "STATUSDISPLAY",
      label: "Status",
    },
  ];

  const [open, setOpen] = useState(false);
  const [dialogData, setDialogData] = useState(null);
  const [data, setData] = useState([]);
  const [formValues, setFormValues] = useState({});
  const [errors, setErrors] = useState({});
  const dispatch = useDispatch();
  const navigate = useNavigate();

  //* use effects
  useEffect(() => {
    loadResources();

    return () => {
      dispatch(resetStateApplications());
    };
  }, []);

  useEffect(() => {
    if (listApplications.length) {
      let remapped = [];
      listApplications.forEach((application) =>
        remapped.push({
          ...application,
          STATUSDISPLAY: translateStatus(application.STATUS),
          SUBMITTED_AT: moment(application.SUBMITTED_AT).format(
            dateFormatWithTime,
          ),
        }),
      );
      setData(remapped);
    }
  }, [listApplications]);

  //* methods
  const loadResources = () => {
    dispatch(resetStateApplications());
    let params = {};
    if (entity) {
      params.INCORPORATION_NUMBER = entity;
    } else {
      setFormValues({
        ...formValues,
        status: "S",
      });
      params.STATUS = "S";
    }

    dispatch(fetchApplications(params));
  };

  const resetFilter = () => {
    setErrors([]);
    dispatch(resetStateApplications());
    setFormValues({
      ...formValues,
      filtered: false,
      date: new Date().toISOString().split("T")[0],
      status: "",
    });
  };

  const fetchItems = () => {
    setData([]);
    dispatch(resetStateApplications());
    let _errors = validate(formValues, {
      // status: formValues?.endDate
      //   ? {}
      //   : {
      //       presence: { allowEmpty: false },
      //     },
      endDate: formValues?.startDate
        ? {
            presence: { allowEmpty: false },
          }
        : {},
    });
    
    if (_errors) {
      setErrors(_errors);
    } else {
      setErrors([]);

      let _payload = {};
      if (formValues.startDate) {
        _payload.startDate = formValues.startDate;
      }

      if (formValues.endDate) {
        _payload.endDate = formValues.endDate;
      }

      if (formValues.status) {
        _payload.STATUS = formValues.status;
      }
      dispatch(fetchApplications(_payload));
    }
  };

  const buildFilterView = () => {
    return (
      <Grid container>
        <Grid item md={3} xs={4} className="padded-grid-item">
          <TextField
            fullWidth
            variant="outlined"
            margin="dense"
            name="Status"
            id="Status"
            select
            label="Status"
            error={errors["status"] ? true : false}
            InputLabelProps={{ shrink: true }}
            helperText={errors["status"] ? errors.status[0] : null}
            onChange={(event) => {
              event.preventDefault();
              setFormValues({
                ...formValues,
                status: event.target.value,
              });
            }}
            value={formValues?.status || null}
          >
            {[{ label: "All", value: null }, ...applicationStatus]
              .filter((i) => i.value !== "D")
              ?.map((option) => {
                return (
                  <MenuItem key={option.label} value={option.value}>
                    {option.label}
                  </MenuItem>
                );
              })}
          </TextField>
        </Grid>

        <Grid item md={3} xs={4} className="padded-grid-item">
          <TextField
            variant="outlined"
            label="Start Date"
            InputLabelProps={{ shrink: true }}
            margin="dense"
            fullWidth
            type="date"
            value={formValues?.startDate}
            InputProps={{
              inputProps: {
                max: new Date().toISOString().split("T")[0] ?? "",
              },
            }}
            onChange={(event) => {
              setFormValues({ ...formValues, startDate: event.target.value });
            }}
          />
        </Grid>

        <Grid item md={3} xs={4} className="padded-grid-item">
          <TextField
            variant="outlined"
            margin="dense"
            fullWidth
            disabled={isEmpty(formValues.startDate)}
            label="End Date"
            type="date"
            InputLabelProps={{ shrink: true }}
            value={formValues?.endDate}
            error={errors["endDate"] ? true : false}
            helperText={errors["endDate"] ? errors.endDate[0] : null}
            InputProps={{
              inputProps: {
                max: new Date().toISOString().split("T")[0] ?? "",
              },
            }}
            onChange={(event) => {
              setFormValues({ ...formValues, endDate: event.target.value });
            }}
          />
        </Grid>

        <Grid
          item
          md={3}
          xs={4}
          className="padded-grid-item"
          style={{
            marginTop: "8px",
          }}
        >
          {formValues?.startDate !== "" && (
            <Button
              onClick={() => {
                setFormValues({ ...formValues, filtered: true });
                fetchItems();
              }}
              size="small"
              id="btn-close"
              margin="dense"
              color="primary"
              variant="contained"
            >
              Get Applications
            </Button>
          )}

          {formValues?.filtered && (
            <Tooltip title="Reset Filter">
              <IconButton
                className="action-icon"
                size="small"
                onClick={() => {
                  resetFilter();
                }}
                style={{ marginLeft: "10px" }}
              >
                <IconClose />
              </IconButton>
            </Tooltip>
          )}
        </Grid>
      </Grid>
    );
  };

  //* builders
  return (
    <>
      {entity === null && (
        <>
          <TopLinks links={topLinks} />
          {buildFilterView()}
        </>
      )}

      {statusGet === "loading" && (
        <LoadingContainer
          hasBackground={entity === null}
          message="Loading applications..."
          id="loading-container-applications"
        />
      )}

      {errorGet !== null && statusGet !== "loading" && (
        <ErrorContainer
          id="error-container-applications"
          hasBackground={entity === null}
          message={errorGet?.message || "An error occurred"}
          onReload={() => {
            loadResources();
          }}
        />
      )}

      {statusGet === "idle" && data?.length <= 0 && errorGet === null && (
        <EmptyDataContainer
          message="No applications found"
          hasBackground={entity === null}
          id="empty-data-users"
        />
      )}

      {data?.length > 0 && errorGet === null && statusGet === "idle" && (
        <AppDataTable
          id="application-list"
          action={[
            {
              action: "View Details",
              onClick: (item) => {
                if (item?.STATUS === "D" || item?.STATUS === "R") {
                  const mappedData = DBApplicationMapper(item);
                  dispatch(setApplicationFormValues(mappedData));
                  setTimeout(() => {
                    navigate("/applications/apply");
                  }, 400);
                } else {
                  setDialogData(item);
                  setOpen(true);
                }
              },
            },
          ]}
          actionIcon={<IconView />}
          columns={columns}
          data={data}
          emptyMessage="Nothing found"
          rowsPerPageOptions={[10, 20, 50, 100]}
          downloadFileName="Applications"
          hasBackground={entity === null}
        />
      )}

      {open && (
        <ApplicationLanding
          data={DBApplicationMapper(dialogData)}
          handleClose={() => {
            setOpen(false);
            if (entity) {
              loadResources();
            } else {
              fetchItems();
            }
          }}
          open={open}
        />
      )}
    </>
  );
};

export default UserApplications;
